<div style="background-color: #F5F7F8; height: 67.5vh; overflow-y: scroll;  padding-top: 20px; overflow-x: hidden;">
    <div style="text-align: center;">
        <img style=" z-index: 100000000; width: 22px; height: 22px; position: relative; top: 5px; float: left; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
        <h2 style="text-align: center; display: inline-block;">Включване в група</h2>
    </div>
    <div  style="width: 95%; margin: auto; background-color: white; margin-top: 10px; margin-bottom: 10px;  border-radius: 10px; padding: 10px; height: fit-content;">
        <div class="form-check col-1" style="display: inline-grid; vertical-align: top; place-items: center;">
            <img style="width: 22px; height: 22px; margin-left: -10px;" src="/assets/images/vouchers/information.svg">
        </div>
        <h4 style="font-weight: bold; display: inline-block; margin-left: 10px;">Как работят груповите поръчки?</h4>
        <ul>
            <li>
                Групите са валидни 24 часа след създаването им или до изчерпване на количеството.
            </li>
            <li>
                Крайната цена зависи от общото заявено количество за продукта от присъединилите се в групата.
            </li>
            <li>
                Ще бъдете таксувани за текущата цена, а в случай, че тя намалее, ще приспаднем разликата
            </li>
        </ul>
    </div>

    <div style="width: 95%; margin: auto; margin-top: 20px; background-color: white; padding: 10px; border-radius: 10px">
        <div style="height: 195px; width: 100%;">
            <div style="height: 180px; margin: 0px;" class="row" *ngIf="this.groupProduct">
                <label style="width: 100px; height: 110px; padding: 3px; border: 1px solid #EDF5FC; border-radius: 10px; margin-top: 10px; vertical-align: unset;" [for]="this.groupProduct!.uuid">
                    <img style="width: 90px; height: 100px; vertical-align: unset;"   [src]="this.productImage" alt="">
                </label>
                <div class="col-7"  style="display: inline-block;  margin-top: 10px; " >
                    <p (click)="this.goToProduct()" style="font-weight: 800; font-size: 13px; margin-bottom: 5px; display: -webkit-box;-webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; height: 40px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-top: 5px; text-overflow: ellipsis;">{{ this.groupProduct!.name }}</p>
                    <div style="min-width: 200px;">
                        <h4 style="margin-top: 2px; margin-bottom: 2px; display: inline-block;">
                            <span [class]="this.inStock ? 'instock' : 'outstock'"> {{ this.inStock ? 'В наличност ' : 'Изчерпано ' }} </span>
                            <p  *ngIf="this.sku?.options?.length" style="font-size: 10px; color: #ADAFBB; margin-bottom: 0px;"><span *ngFor="let option of this.sku?.options || []; index as i">&nbsp;{{ option.option?.display_name + ': ' + this.returnOptionValue(option) + ((i != (this.sku?.options?.length || 0)  - 1) ? ' |' : '')}}</span></p>
                        </h4>
                        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 5px; margin-bottom: 10px;">
                        <div class="join-group-main-price-wrap">
                          <app-price
                            class="join-group-main-price"
                            [amount]="getSelectedUnitPriceBase()"
                            layout="stack"
                          ></app-price>
                        </div>
                        <p class="join-group-suggested-deal">
                          {{ this.getSuggestedDeal() }}
                        </p>
                        <div  style="float: right; top: -60px; right: -35px; display: inline-block; padding: 10px; position: relative; ">
                            <img [class]="this.selectedAmount == 1 ? 'btnDsbld' : ''" (click)="this.decreaseAmount()" style="width: 22px; display: inline-block; margin-left: 10px; margin-right: 5px;" src="/assets/images/product/minus.svg" alt="">
                            <span> {{this.selectedAmount}} </span>
                            <img (click)="this.increaseAmount()" [class]="this.isIncreaseButtonDsbld ? 'btnDsbld' : ''" style=" width: 22px; display: inline-block; margin-left: 5px;" src="/assets/images/product/plus.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 15px; margin-bottom: 10px;">
        </div>
    </div>

    <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <p style="font-weight: bold; width: 80%; display: inline-block;">Ценоразпис</p>
        <div *ngFor="let pricing of this.groupProduct?.pricing || []" class="row join-group-pricing-row">
          <span class="col-4 join-group-pricing-range">
            {{ (pricing.quantity_to == pricing.quantity_from) ? this.getFullAmountLabel(pricing.quantity_from) : pricing.quantity_from }}
            <span>{{ (pricing.quantity_to != pricing.quantity_from) ? ('- ' + this.getFullAmountLabel(pricing.quantity_to)) : "" }}</span>
          </span>
          <span [class]="(pricing.quantity_from > 1) ? 'col-6 join-group-pricing-value' : 'col-7 join-group-pricing-value'">
            <app-price
              [amount]="getPricingAmountBase(pricing.price_per_piece)"
              layout="inline"
            ></app-price>
            <span>/бр.</span>
          </span>

          <span *ngIf="(pricing.quantity_from > 1)" class="bg-primary col-1 join-group-pricing-discount-badge">
            {{ this.calculateDiscount(this.getPricingFor(1), pricing.price_per_piece) }}
          </span>
        </div>
        <div class="row join-group-pricing-row">
          <span class="col-4 join-group-pricing-range">{{ 'над ' + this.maxAmountForPricing + ' броя' }}</span>
          <span class="col-7 join-group-pricing-value">
            <app-price
              [amount]="getPricingAmountBase(this.minPriceForPricing)"
              layout="inline"
            ></app-price>
            <span>/бр.</span>
          </span>
        </div>
    </div>

    <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <p style="font-weight: bold; width: 80%; display: inline-block; margin-bottom: 5px;">Доставка</p>
        <p class="join-group-delivery-free-label">
          Безплатна за поръчки над
          <app-price
            [amount]="getFreeDeliveryThresholdBase()"
            layout="inline"
          ></app-price>!
        </p>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
        <div class="join-group-delivery-row">
          <span style="width: fit-content;">Изпращане до офис на куриер: </span>
          <span class="join-group-delivery-value">
            <app-price
              [amount]="getCourierOfficeDeliveryBase()"
              layout="inline"
            ></app-price>
          </span>
        </div>

        <div class="join-group-delivery-row">
          <span style="width: fit-content;">Изпращане до адрес: </span>
          <span class="join-group-delivery-value">
            <app-price
              [amount]="getAddressDeliveryBase()"
              layout="inline"
            ></app-price>
          </span>
        </div>
    </div>
</div>

<div style="box-shadow: 0px -3px 5px #f5f7f8;position: fixed; bottom: 0; width: 100%; height: 32vh; background-color: white; margin: 0px; padding: 10px;" >
    <div class="row" style="margin-top: 4px;">
      <div class="col-6 join-group-summary-label" style="text-align: left;">Стандартна цена:</div>
      <div class="col-6 join-group-summary-value">
        <app-price
          [amount]="getStandardUnitPriceBase()"
          layout="inline"
        ></app-price>
        <span>/бр.</span>
      </div>
    </div>

    <div class="row" style="margin-top: 4px;">
      <div class="col-5 join-group-summary-label" style="text-align: left;">Текуща групова цена:</div>
      <div class="col-7 join-group-summary-value">
        <app-price
          [amount]="getSelectedUnitPriceBase()"
          layout="inline"
        ></app-price>
        <span>/бр.</span>
        &nbsp;
        <span class="bg-primary join-group-summary-discount-badge">
        {{ this.calculateDiscount(this.getPricingFor(1), this.total()) }}
      </span>
      </div>
    </div>

    <div class="row" style="margin-top: 4px;">
      <div class="col-6 join-group-summary-label" style="text-align: left;">Поръчани:</div>
      <div class="col-6 join-group-summary-value" style="text-align: right;">
        {{ this.selectedAmount + ' броя' }}
      </div>
    </div>

    <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 15px; margin-bottom: 10px;">

    <div class="row join-group-total-row">
      <div class="col-6" style="text-align: left;">Обща цена:</div>
      <div class="col-6" style="text-align: right;">
        <app-price
          [amount]="getAllAmountBase()"
          layout="inline"
        ></app-price>
      </div>
    </div>


    <div style="text-align: center; width: 100%; margin-top: 7px;" >
        <div style="text-align: center; width: 95%; margin: auto;">
            <button type="button" class="btn btn-primary" style="width: 100%; margin: auto; height: 45px;" (click)="this.createGroup()">Продължи</button>
        </div>
    </div>
</div>
